import Vue from 'vue';
import $ from 'jquery';
import select2 from '../../../libs/select2';


Vue.directive('select2', {
    inserted(el) {
        const filtersContainer = $(el).closest(".filter__filters-controls")

        $(el).select2({
            minimumResultsForSearch: -1,
            dropdownParent: filtersContainer
        });
        

        $(el).on('select2:select', () => {
            const event = new Event('change', { bubbles: true, cancelable: true });
            el.dispatchEvent(event);
        });

        $(el).on('select2:unselect', () => {
            const event = new Event('change', { bubbles: true, cancelable: true })
            el.dispatchEvent(event)
        });

        $(el).on('select2:open', () => {
            document.body.classList.add('select2-dropdown-open');
        });

        $(el).on('select2:close', () => {
            document.body.classList.remove('select2-dropdown-open');
        });
    },
});